export const addressBook = {
  addNewShippingAddress: 'Ajouter une nouvelle adresse de livraison',
  editShippingAddress: 'Modifier l\'adresse de livraison',
  areYouSureToDeleteAddress: 'Êtes-vous sûr de vouloir supprimer cette adresse?',
  addNewAddress: 'Ajouter une nouvelle adresse',
  addAddress: 'Ajouter une adresse',
  updateAddress: 'Mettre à jour l\'adresse',
  backToAddressList: 'Retour à la liste d\'adresses',
  button: {
    addAddress: 'Ajouter une adresse',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    update: 'Mettre à jour',
  },
  heading: {
    addAddress: 'Ajouter une adresse',
    editAddress: 'Modifier l\'adresse',
  },
};

export const addressCard = {
  default: 'Par défaut',
  selected: 'Sélectionnée',
  setAsDefault: 'Définir par défaut',
  shipTo: 'Expédier à',
  billTo: 'Facturer à',
  phoneNumber: 'Numéro de téléphone',
  mobileNumber: 'Numéro de cellulaire',
};

export const addressForm = {
  title: 'Titre',
  firstName: {
    label: 'Prénom',
    placeholder: 'Prénom',
  },
  lastName: {
    label: 'Nom de famille',
    placeholder: 'Nom de famille',
  },
  address1: 'Adresse 1',
  address2: 'Adresse 2 (facultatif)',
  country: 'Pays',
  city: {
    label: 'Ville',
    placeholder: 'Ville',
  },
  state: 'État/Province',
  zipCode: {
    label: 'Code ZIP/Code postal',
    placeholder: 'Code ZIP/Code postal',
  },
  phoneNumber: {
    label: 'Numéro de téléphone (facultatif)',
    placeholder: '(555) 555 - 0123',
  },
  saveAsDefault: 'Sauvegarder par défaut',
  chooseAddress: 'Choisir une adresse',
  streetAddress: 'Adresse municipale',
  aptSuite: 'App., bureau',
  selectOne: 'Sélectionner...',
  selectOneState: 'Sélectionner l\'état/la province',
  setAsDefault: 'Définir par défaut',
  titleRequired: 'Le titre est obligatoire.',
  userAddressAddSuccess: 'La nouvelle adresse a été ajoutée avec succès!',
  userAddressUpdateSuccess: 'L\'adresse a été mise à jour avec succès!',
  userAddressDeleteSuccess: 'L\'adresse a été supprimée avec succès!',
  invalidAddress: 'L\'adresse n\'est pas valide. Veuillez vérifier votre saisie et réessayer ou continuer avec cette adresse.',
  label: {
    name: 'Nom',
    attn: 'À l\'attention de : Nom/N° de réf.',
    bldg: 'Adresse ligne 1',
    houseNumberAndStreetName: 'Adresse ligne 2',
    cityAndPostalCode: 'Ville / Code postal',
    mobileCity: 'Ville',
    mobileState: 'État / Province',
    mobileZipCode: 'Code ZIP / Code postal',
    email: 'Courriel',
    telephone: 'Téléphone',
    fax: 'Télécopieur',
    mandatoryFields: 'Vous devez remplir ces champs',
  },
  placeholder: {
    name: 'Nom',
    attn: 'À l\'attention de : Nom/N° de réf.',
    bldg: 'Adresse ligne 1',
    streetName: 'Adresse ligne 2',
    select: 'Sélectionner le pays',
    selectState: 'Sélectionner l\'état/la province',
    postalCode: 'Code ZIP/Code postal',
    email: 'Courriel',
    telephone: 'Téléphone',
    fax: 'Télécopieur',
  },
  button: {
    onetime: 'Utilisation unique',
    cancel: 'Annuler',
  },
  onetime: {
    successMsg: 'Adresse à usage unique créée avec succès',
  },
};
export const addressMessages = {
  setAsDefaultSuccessfully: 'L\'adresse {{ streetAddress }} a été définie par défaut avec succès',
};
export const addressValidation = {
  serviceUnavailable: 'Nous n\'avons pas pu valider cette adresse pour le moment. Veuillez réessayer.',
  validating: 'Validation de l\'adresse en cours...',
  enteredAddress: 'Ce que vous avez saisi',
  // A. Confirmer l'adresse recommandée (recommendation.png).
  confirmDialog: {
    title: 'Confirmez votre adresse de livraison',
    subtitle: 'Passez en revue les modifications recommandées',
    recommendedAddress: 'Recommandée',
    back: 'Retour',
    confirm: 'Confirmer',
  },
  // B. Fournir les informations manquantes (addition.png).
  missingInfoDialog: {
    title: 'Informations manquantes',
    subtitle: 'Votre immeuble compte-t-il plusieurs unités?',
    inputLabel: 'Appartement, bureau ou unité',
    helperText: 'Laissez vide s\'il n\'y a pas plusieurs unités',
    goBack: 'Retour',
    continue: 'Continuer',
  },
  // C. Corriger l'adresse (correction.png).
  fixDialog: {
    title: 'Nous n\'avons pas pu vérifier votre adresse',
    subtitle: 'Passez en revue les problèmes de vérification',
    issuesTitle: 'Problèmes de vérification',
    body: 'Nous n\'avons pas pu vérifier cette adresse. Veuillez la vérifier et la corriger avant de continuer.',
    makeChanges: 'Apporter des modifications',
    useEntered: 'Utiliser l\'adresse saisie',
  },
};
export const address = {
  addressBook,
  addressForm,
  addressCard,
  addressMessages,
  addressValidation,
};
